import * as yup from 'yup';
import { FIELDS } from 'modules/cm/fields/types';
import { nullableNumber, nullableString } from 'utils/form/validation';
import { CurrentPension } from 'modules/cm/pages/CaseDetailsPage/CaseDetailsPage.types';

export default yup.object().shape<CurrentPension>({
  [FIELDS.CURRENT_STATE_PENSION]: nullableNumber(),
  [FIELDS.CURRENT_DB_NAME_OF_SCHEME]: nullableString(),
  [FIELDS.CURRENT_DB_ANNUAL_INCOME]: nullableNumber(),
  [FIELDS.CURRENT_DB_PERCENT_PASSED_ON_DEATH]: nullableNumber(),
  [FIELDS.CURRENT_DC_NAME_OF_SCHEME]: nullableString(),
  [FIELDS.CURRENT_DC_CURRENT_VALUE]: nullableNumber(),
  [FIELDS.CURRENT_DC_PERCENT_PASSED_ON_DEATH]: nullableNumber(),
  [FIELDS.CURRENT_DC_ANNUAL_INCOME_DRAWN]: nullableNumber(),
  [FIELDS.CURRENT_ANNUITY_NAME_OF_ANNUITY_PROVIDER]: nullableString(),
  [FIELDS.CURRENT_ANNUITY_GROSS_ANNUAL_INCOME]: nullableNumber(),
  [FIELDS.CURRENT_ANNUITY_PERCENT_PASSED_ON_DEATH]: nullableNumber(),
});
